/* eslint-disable */
import React, { useState, useEffect } from 'react';
import NavFormIndustryDropdown from '../NavFormIndustryDropdown';

const DropdownFilter = ({ report, calendarYearEnd, current, activeTab, naicsCode = '', options, onClick, clas, isMonthlyAvailable, getMonthlyForecastScenario, monthlyCompareWithOptions, youAnnualOptions, youMonthlyOptions, peerAnnualOptions, peerMonthlyOptions }) => {
  // current is the selected options
  // options are the naics, size, region, and year
  // currentNewFilters is selected compare_with, display_columns_by, report_period
  const [filters, setFilters] = useState({
    code: '',
    region: '',
    revenue_band: '',
    year: '',
    number_of_pros: '',
    entity_type: 'All',
    datatype: 'Private',
    dataset: 'Peers',
    compare_with: 'Peers',
    display_columns_by: 'Years',
    report_period: '2 Years',
    date_through_monthly_month: '',
    date_through_monthly_year: '',
  })

  const [filterOptions, setFilterOptions] = useState({
    code: [],
    region: [],
    revenue_band: [],
    year: [],
    number_of_pros: [],
    entity_type: [['All', 'All'], ['For Profit', 'for_profit'], ['Nonprofit', 'nonprofit']],
    datatype: ['All', 'Private', 'Public'],
    dataset: [],
    compare_with: [],
    display_columns_by: [],
    report_period: [],
    date_through_monthly_month: [['', ''], ['January', 1], ['February', 2], ['March', 3], ['April', 4], ['May', 5], ['June', 6], ['July', 7], ['August', 8], ['September', 9], ['October', 10], ['November', 11], ['December', 12]],
    date_through_monthly_year: []
  })

  useEffect(() => {
    let actualFilters = (activeTab && activeTab?.details && Object.keys(activeTab?.details || {}).length > 0) ? activeTab.details : current;

    if (actualFilters) {
      if (report == 'customreport' || report === 'money' || report === 'people' || report === 'customers' || report === 'audit') {
        let displayColumnsBy = actualFilters.display_columns_by;
        let reportPeriodOptions = [];
        let yearOptions = options.year;
        let compareWithOptions = [];

        if (report !== 'audit') {
          if (isMonthlyAvailable && displayColumnsBy === 'Years') {
            reportPeriodOptions = ['2 Years', '3 Years', '4 Years', 'All Years', 'Year to Date'];
            compareWithOptions = options['compare_with'];
          } else if (displayColumnsBy === 'Years') {
            reportPeriodOptions = ['2 Years', '3 Years', '4 Years', 'All Years'];
            compareWithOptions = options['compare_with'];
          }

          if (displayColumnsBy === 'Months') {
            reportPeriodOptions = ['Full Year', 'Trailing 12', 'CM + YTD']
            if (report === 'money') {
              compareWithOptions = monthlyCompareWithOptions;
            } else {
              compareWithOptions = peerMonthlyOptions['year'].length === 0 ? ['None', 'YOY'] : ['None', 'YOY', 'Peers'];
            }
          }
        } else {
          compareWithOptions = options['compare_with'];
        }

        setFilters((prevState) => {
          return {
            ...prevState,
            code: actualFilters.code || '',
            region: actualFilters.region || '',
            revenue_band: actualFilters.revenue_band || '',
            year: actualFilters.year || '',
            number_of_pros: actualFilters.number_of_pros || '',
            compare_with: actualFilters.compare_with || 'Peers',
            display_columns_by: displayColumnsBy || 'Years',
            entity_type: actualFilters.entity_type || 'All',
            report_period: actualFilters.report_period || '2 Years',
            monthly_forecast_scenarios: actualFilters.monthly_forecast_scenarios || '',
            date_through_monthly_month: actualFilters.date_through_monthly_month || '',
            date_through_monthly_year: actualFilters.date_through_monthly_year || actualFilters.year,
          }
        })

        setFilterOptions((prevState) => {
          return {
            ...prevState,
            code: options.code || [],
            region: options.region || [],
            revenue_band: options.revenue_band || [],
            year: yearOptions || [],
            number_of_pros: options.number_of_pros || [],
            compare_with: compareWithOptions,
            display_columns_by: isMonthlyAvailable ? ['Years', 'Months'] : ['Years'],
            report_period: reportPeriodOptions,
            monthly_forecast_scenarios: options['monthly_forecast_scenarios'] || [],
            date_through_monthly_year: yearOptions || ''
          }
        })

      } else if (report === 'industry') {
        setFilters((prevState) => {
          return {
            ...prevState,
            datatype: actualFilters.datatype || '',
            dataset: actualFilters.dataset || '',
            code: actualFilters.code || '',
            region: actualFilters.region || '',
            revenue_band: actualFilters.revenue_band || '',
            year: actualFilters.year || ''
          }
        })

        setFilterOptions((prevState) => {
          return {
            ...prevState,
            dataset: ['Peers', 'NSCHBC'],
            code: options.code || [],
            region: options.region || [],
            revenue_band: options.revenue_band || [],
            year: options.year || []
          }
        })
      } else if (report === 'nschbc-employee-data') {
        setFilters((prevState) => {
          return {
            ...prevState,
            code: '',
            datatype: 'Private',
            dataset: actualFilters.dataset || '',
            region: actualFilters.region || '',
            revenue_band: actualFilters.revenue_band || '',
            year: actualFilters.year || ''
          }
        })

        setFilterOptions((prevState) => {
          return {
            ...prevState,
            code: options.code || [],
            datatype: ['Private'],
            dataset: ['NSCHBC w/Employee Data', 'NSCHBC'],
            region: options.region || [],
            revenue_band: options.revenue_band || [],
            year: options.year || []
          }
        })
      }
    }
  }, [activeTab, current, options])

  const updateFilters = ({ target }) => {
    let updated = '';
    updated = target.name == 'year' ? parseInt(target.value) : target.value;
    let yearOptions = filterOptions.year;

    switch (target.name) {
      case 'code':
        setFilters((prevState) => {
          return { ...prevState, code: updated }
        });
        break;
      case 'region':
        setFilters((prevState) => {
          return { ...prevState, region: updated }
        });
        break;
      case 'revenue_band':
        setFilters((prevState) => {
          return { ...prevState, revenue_band: updated }
        });
        break;
      case 'datatype':
        setFilters((prevState) => {
          return { ...prevState, datatype: updated }
        });
        break;
      case 'dataset':
        setFilters((prevState) => {
          return { ...prevState, dataset: updated }
        });
        break;
      case 'entity_type':
        setFilters((prevState) => {
          return { ...prevState, entity_type: updated }
        });
        break;
      case 'year':
        setFilters((prevState) => {
          return { ...prevState, year: updated, date_through_monthly_month: null, date_through_monthly_year: updated }
        });
        break;
      case 'date_through_monthly_year':
        setFilters((prevState) => {
          return { ...prevState, report_period: 'Full Year', year: updated, date_through_monthly_year: updated }
        });
        break;
      case 'date_through_monthly_month':
        setFilters((prevState) => {
          return { ...prevState, report_period: 'Full Year', date_through_monthly_month: updated }
        });
        break;
      case 'number_of_pros':
        setFilters((prevState) => {
          return { ...prevState, number_of_pros: updated }
        });
        break;
      case 'compare_with':
        if (filters.display_columns_by === 'Months') {
          setFilters((prevState) => {
            return { ...prevState, year: yearOptions[yearOptions.length - 1] }
          });
        }
        if (filters.display_columns_by === 'Years') {
          setFilters((prevState) => {
            return { ...prevState, year: yearOptions[yearOptions.length - 1] }
          });
        }

        setFilters((prevState) => {
          return { ...prevState, compare_with: updated }
        });
        break;
      case 'display_columns_by':
        let reportPeriodOptions = [];
        let reportPeriodDefault = '';
        let compareWithOptions = [];
        let compareWith = '';

        if (isMonthlyAvailable && updated === 'Years') {
          reportPeriodOptions = ['2 Years', '3 Years', '4 Years', 'All Years', 'Year to Date']
          reportPeriodDefault = '2 Years';
          compareWithOptions = options['compare_with'];
          compareWith = 'Peers';

          setFilters((prevState) => {
            return { ...prevState, year: yearOptions[yearOptions.length - 1] }
          })
        } else if (updated === 'Years') {
          reportPeriodOptions = ['2 Years', '3 Years', '4 Years', 'All Years'];
          reportPeriodDefault = '2 Years';
          compareWithOptions = options['compare_with'];
          compareWith = 'Peers';

          setFilters((prevState) => {
            return { ...prevState, year: yearOptions[yearOptions.length - 1] }
          })
        } else if (updated === 'Months') {
          reportPeriodOptions = ['Full Year', 'Trailing 12', 'CM + YTD']
          reportPeriodDefault = 'Full Year';

          if (report === 'money') {
            compareWithOptions = monthlyCompareWithOptions
            compareWith = 'Default:YOY';
          } else {
            compareWithOptions = peerMonthlyOptions['year'].length ? ['None', 'YOY'] : ['None', 'YOY', 'Peers'];
            compareWith = 'YOY';
          }

          setFilters((prevState) => {
            return { ...prevState, year: yearOptions[yearOptions.length - 1] }
          })
        }

        setFilters((prevState) => {
          return { ...prevState, compare_with: compareWith, display_columns_by: updated, report_period: reportPeriodDefault, monthly_forecast_scenarios: '' }
        });

        setFilterOptions((prevState) => {
          return { ...prevState, compare_with: compareWithOptions, report_period: reportPeriodOptions }
        })
        break;
      case 'report_period':
        let selectedYear = activeTab?.details?.year || current?.year;
        compareWithOptions = options['compare_with'];
        let dateThrough = updated !== 'Full Year' ? '' : (activeTab?.details?.date_through_monthly_month || current?.year);

        if (updated === 'Year to Date') {
          compareWithOptions = ['None', 'Peers']
          compareWith = 'Peers'
          selectedYear = yearOptions[yearOptions.length - 1]

        } else if (filters.display_columns_by === 'Years' && updated !== 'Year to Date') {
          compareWithOptions = ['None', 'Peers', 'Practice']
          compareWith = 'Peers'
          selectedYear = yearOptions[yearOptions.length - 1]

        } else if (filters.display_columns_by === 'Months' && updated !== 'Year to Date') {
          if (report === 'money') {
            compareWithOptions = monthlyCompareWithOptions
            compareWith = updated === 'Full Year' || updated === 'Trailing 12' || updated === 'CM + YTD' ? 'Default:YOY' : 'YOY';
            selectedYear = yearOptions[yearOptions.length - 1]

          }
        }

        setFilters((prevState) => {
          return { ...prevState, year: selectedYear }
        })

        setFilters((prevState) => {
          return { ...prevState, date_through_monthly_month: dateThrough, compare_with: compareWith, report_period: updated }
        });

        setFilterOptions((prevState) => {
          return { ...prevState, compare_with: compareWithOptions }
        })
        break;
      case 'forecast_scenario':
        setFilters((prevState) => {
          return { ...prevState, monthly_forecast_scenarios: updated }
        });

        setFilters((prevState) => {
          return { ...prevState, compare_with: 'Forecast Scenario' }
        });
        break;
    }
  };

  const handleAuditCompareScenario = (value) => {
    setFilters((prevState) => {
      return { ...prevState, compare_with: value }
    });
    getMonthlyForecastScenario(value)
  }

  const buildFilter = ({ list, selected, key, label, styleName, optionCallback }) => {
    if (key === 'year' && !list.includes(selected)) {
      let lastPeerYear = list[list.length - 1]
      if (selected > lastPeerYear) {
        for (let i = lastPeerYear; i <= selected; i++) {
          list.push(i)
        }
      }
    }
    if (list) return (
      <div className={styleName} id={key + '-filter'}>
        <label htmlFor={key} className='text-left'>{label}</label>
        <select id={key} name={key} value={selected} onChange={updateFilters} className={`${styleName} ${key === 'code' ? 'industry' : ''}`}>
          {list.map((filter, i) => {
            if (optionCallback) return optionCallback(filter, i);
            let displayVal = filter;
            let realVal = filter;
            if (key === 'number_of_pros') {
              if (filter == 0) {
                displayVal = 'All'
              }
              if (filter == 4) {
                displayVal = '4+'
              }
            }

            if (key === 'year') {
              if (!calendarYearEnd) { displayVal += 1 }
            }

            if (key === 'date_through_monthly_month' || key === 'entity_type') {
              displayVal = filter[0]
              realVal = filter[1]
            }

            return (
              <option key={i} value={realVal} className='option-dropdown-filter'>
                {displayVal}
              </option>
            );
          })}
        </select>
      </div>
    )
  }

  const buildFilterWGroups = ({ list, selected, key, label, styleName }) => {
    let defaultSelected = selected === 'YOY' ? 'Default:YOY' : selected === 'Peers' ? 'Default:Peers' : selected;

    const handleFilterGroups = (e) => {

      if (report === 'audit') {
        handleAuditCompareScenario(e.target.value)
      } else {
        updateFilters(e)
      }
    }

    if (list) {
      let arrList = list

      return (
        <div className={styleName} id={key + '-filter'}>
          <label htmlFor={key} className='text-left'>{label}</label>
          <select name={key} value={defaultSelected} onChange={(e) => handleFilterGroups(e)} className={`${styleName} ${key === 'code' ? 'industry' : ''}`}>
            {arrList.map((filter, i) => {
              let groupLabel = filter[0];

              return (
                <optgroup key={`optgroup-${i}`} label={groupLabel}>
                  {
                    filter[1].map((filterOption, j) => {
                      return (
                        <option key={`option-${i}-${j}`} value={`${groupLabel}:${filterOption}`} className='option-dropdown-filter'>
                          {filterOption}
                        </option>
                      )
                    })
                  }
                </optgroup>
              )
            })}
          </select>
        </div>
      )
    }
  }

  let reportBtnClass;
  if (report === 'money' || report === 'industry' || report === 'customreport' || report === 'nschbc-employee-data') {
    reportBtnClass = 'run-report-btn'
  } else if (report === 'people') {
    reportBtnClass = 'run-report-btn-people'
  } else if (report === 'customers') {
    reportBtnClass = 'run-report-btn-customers'
  } else if (report === 'audit') {
    reportBtnClass = 'run-report-btn-audit'
  }

  clas = report == 'audit' ? 'audit-dropdown-filters' : clas
  let naics62Code = naicsCode.startsWith('621');
  let notReportsPage = ['customreport', 'audit', 'planning', 'industry', 'nschbc-employee-data'];

  return (
    <form id='dropdown-filter-id' onSubmit={(e) => onClick(e, filters)}>
      <div className={'pvd-filter ' + clas}>
        {filters && <NavFormIndustryDropdown selectedCode={filters.code} codeOptions={filterOptions.code} setSelectedFilters={setFilters} />}
        {report !== 'nschbc-employee-data' ? buildFilter({
          list: filterOptions.entity_type,
          selected: filters.entity_type,
          key: 'entity_type',
          label: 'Entity Type',
          styleName: 'entity_type-filter filter-item-side-bar',
        }) : null}
        {report !== 'nschbc-employee-data' ? buildFilter({
          list: ['All', 'Private', 'Public'],
          selected: filters.datatype,
          key: 'datatype',
          label: 'Data Type',
          styleName: 'datatype-filter filter-item-side-bar',
        }) : null}
        {buildFilter({
          list: filterOptions.revenue_band,
          selected: filters.revenue_band,
          key: 'revenue_band',
          label: 'Revenue',
          styleName: 'revenue-band-filter filter-item-side-bar',
        })}
        {buildFilter({
          list: filterOptions.region,
          selected: filters.region,
          key: 'region',
          label: 'Region',
          styleName: 'region-filter filter-item-side-bar',
        })}
        {report === 'industry' || report === 'nschbc-employee-data' ? buildFilter({
          list: filterOptions.dataset,
          selected: filters.dataset,
          key: 'dataset',
          label: 'Dataset',
          styleName: 'dataset-filter filter-item-side-bar',
        }) : null}
        {report !== 'customreport' && naics62Code ? buildFilter({
          list: filterOptions.number_of_pros,
          selected: filters.number_of_pros,
          key: 'number_of_pros',
          label: '# Doctors',
          styleName: 'number-of-pros-filter filter-item-side-bar',
        }) : null}
        {!notReportsPage.includes(report) ?
          buildFilter({
            list: filterOptions.display_columns_by,
            selected: filters.display_columns_by,
            key: 'display_columns_by',
            label: 'Display columns by',
            styleName: 'display-columns-filter filter-item-side-bar',
          }) : null}
        {!notReportsPage.includes(report) ?
          buildFilter({
            list: filterOptions.report_period,
            selected: filters.report_period,
            key: 'report_period',
            label: 'Report Period',
            styleName: 'report-period-filter filter-item-side-bar',
          }) : null}
        {(filters.display_columns_by === 'Years' && report === 'money') || report === 'people' || report === 'customers' ?
          buildFilter({
            list: filterOptions.compare_with,
            selected: filters.compare_with,
            key: 'compare_with',
            label: 'Compare with',
            styleName: 'compare-with-filter filter-item-side-bar',
          }) : null}
        {(filters.display_columns_by === 'Months' && report === 'money') ?
          buildFilterWGroups({
            list: monthlyCompareWithOptions,
            selected: filters.compare_with,
            key: 'compare_with',
            label: 'Compare with',
            styleName: 'compare-with-filter filter-item-side-bar',
          }) : null}
        {report === 'audit' ?
          buildFilterWGroups({
            list: filterOptions.compare_with,
            selected: filters.compare_with,
            key: 'compare_with',
            label: 'Compare with',
            styleName: 'compare-with-filter filter-item-side-bar',
          }) : null}
        {report !== 'planning' &&
          buildFilter({
            list: filterOptions.year,
            selected: filters.year,
            key: 'year',
            label: calendarYearEnd ? 'Calendar Year' : 'Fiscal Year',
            styleName: 'year-filter filter-item-side-bar',
          })}
        {(filters.display_columns_by === 'Months' && report === 'money') ?
          <div className='monthly-date-through-filter'>
            <span className='date_through-label'>Date Through:</span>
            {buildFilter({
                list: filterOptions.date_through_monthly_month,
                selected: filters.date_through_monthly_month,
                key: 'date_through_monthly_month',
                label: 'Month',
                styleName: 'compare-with-filter date_through-filter-item-side-bar',
              })}
            {buildFilter({
                list: filterOptions.date_through_monthly_year,
                selected: filters.date_through_monthly_year,
                key: 'date_through_monthly_year',
                label: 'Year',
                styleName: 'year-filter date_through-filter-item-side-bar',
              })
            }
          </div>
          : null}
        {report !== 'money'
          ? <button className={reportBtnClass} type='submit'>Run Report</button>
          : <div className='apply-filters-btns'>
            <button className={reportBtnClass} type='submit' name='applyToThisTab'>Apply to this Tab</button>
            <span style={{ 'textAlign': 'center' }}>OR</span>
            <button className={reportBtnClass} type='submit' name='applyToAllTabs'>Apply to All Tabs</button>
          </div>
        }
      </div>
    </form>
  );
};
export default DropdownFilter;